import React, { useEffect, useRef, useState } from 'react'
import { FoundationsConstants } from '../../FoundationsConstants'
import {
    IAggricateObj,
    IBinResponseObj,
    IBusinessParameter,
    IMeasureSetList,
    IMetadataFilterSearchList,
    ISingleValueReportList,
    IVUParamsSubCategory,
    useGetAggricateListMutation,
    useGetBinListMutation,
    useGetBusinessParameterListMutation,
    useGetBusinessParametersMutation,
    useGetFilterSearchListMetaDataValueMutation,
    useGetMeasureSetListMutation,
    useGetSingleValueReportsMutation,
} from '../../Redux/VisualUnits/vuParamSlice'
import { FilterValueOption } from '../../GenericComponents/filterTypes'
import { TGetFilterVal } from '../VisualUnitParams/GenericFilters'
import { T_VuParamsActionState } from './DashboardVuParams'
import SelectionIndicator from '../SelectionIndicator' // using that in next PR
import ErrorBlock from '../ValidationsErrorBlock'
import {VisualUnitApiDTO_EditSaveVisualUnit} from '../../Interfaces/APIContracts/VisualUnitApiDTO_EditSaveVisualUnit'
import {
    checkIsInvalidFilter,
    checkIsInvalidDimension,
    formedErrorText,
    helperFormDimensionItem,
    helperFormFilterItem,
    helperFormMeasureItem,
    IFilterConditions,
    isAddParmsCall,
    isDimensioncall,
    isDimensionColcall,
    isFilterCall,
    isUpdateParamsCall,
    validateGenericFilterValues,
    validateParams,
    checkDimensionsCount,
} from '../VuParamsHelpers'
import { TBpObject } from '../VisualUnitParams/ConvertFilterDisplayText'
import { getVisualUnitParamsIndex } from '../../VisualunitHelpers'
import VuParamsFilterRegion from './VuParamsFilterRegion'
import { useSelectionManager } from './useMetaDataSelection'
import {useApplyHighlight} from '../../GenericComponents/useApplyHighlight'
import SuccessBlock from '../ValidationSuccessBlock'
import { useSelector } from 'react-redux'
import { getCurrentUserData, RootState } from '../../Redux/store'

interface IUpdateParamsProps {
    data: any
}
export type IBusinessParamsOptions = {
    Id: number
    Guid: string
    Name: string
    Description: string
    DataType: number
    BPValue: string
    IsSecured: boolean
    Available: string
  }
const VisualUnitParamsDialog = (props: {
    groupCategoriesData: any
    categoriesData: any
    paramsAction: T_VuParamsActionState
    vuId: number
    addMeasureFn: (dialogProps: any, callFrom: "add" | "save") => void
    onClose: Function
    selectedParameters: IUpdateParamsProps
    availMeasures: any[]
    updateIndex: number | null
    vuObjFromStore: string,
    getHLMetadata: (key: string, payload: {conditions: IFilterConditions[]}) => void
    setFieldErrors: Function
}) => {
    const {
        categoriesData,
        groupCategoriesData,
        paramsAction,
        vuId,
        addMeasureFn,
        onClose,
        selectedParameters,
        availMeasures,
        updateIndex,
        vuObjFromStore,
        getHLMetadata,
        setFieldErrors
    } = props

    //refs
    let selectedCategoriesRef = useRef<Object>({})
    let ExpandedCatRef = useRef<string | null>(null)
    let firstFetchRef = useRef<boolean | null>(null)
    // let RadioBtCheckedRef = useRef<number | null>(null)
    let elementRef = useRef<Map<number, HTMLTableCellElement>>(new Map())
    let genericFilterValRef = useRef<any>(null)
    let noScrollRef = useRef<null | boolean>(null) //FP-11851 making sure scroll does happen only once
    let selectedDurationsFilter = useRef<string>("")
    let bpObjectRef = useRef<TBpObject>(null)
    let invalidParamsRef = useRef<boolean>(false)
    //vars
    let isListItemClicked: boolean = false
    let showQuickSearchRef = useRef<boolean>(false)
    // let firstFetchRef = useRef<boolean>(true) //to avoid scroll feature after first render of update call //Its need to fix, not working as expected.
    
    //mutations
    const [callGetAggricateList] = useGetAggricateListMutation()
    const [callGetMeasureSets] = useGetMeasureSetListMutation()
    const [callGetBusinessParamList] = useGetBusinessParameterListMutation()
    const [callGetSingleValParamList] = useGetSingleValueReportsMutation()
    const [callGetBusinessParameters] = useGetBusinessParametersMutation()
    const [callGetMetaDataSearchList] = useGetFilterSearchListMetaDataValueMutation()
    const [callGetBinList] = useGetBinListMutation()
    //state
    const aggrSelection = useSelectionManager({
        initialValue: {},
        isMulti: false,
    })
    const filterSelection = useSelectionManager({
        initialValue: [],
        isMulti: true
    });
    const [businessParamChecked, setBusinessParamChecked]= useState<0 | 1>(0) //need flag to trigger re-render of GenericFilter.tsx
    const [displayType, setDisplayType] = useState<string>('') //to show/hide filter value dropdown
    const [expandedCat, setExpandedCategoris] = useState<number[]>([])
    const [selectedCatFilter, setSelectedCatFilter] = useState<string>('all')
    const [showBusinessParameter, setShowBusinessParameter] = useState<boolean>(true)
    const [showSelectionIndicator, setShowSelectionIndicator] = useState<number | null>(null)
    const [catData, setCatData] = useState<any[]>([])
    const [groupedCat, setGroupedCat] = useState<any>({})
    const [debouncedQuery, setDebouncedQuery] = useState('')
    const [isAggrigateLoading, setIsAggrigateLoading] = useState<boolean>(false)
    const [fetchingResponse, setFetchingResponse] = useState<boolean>(false)
    // const [selectedCheckboxValues, setSelectedCheckboxValues] = useState<any[]>([])
    const [aggricateListResp, setAggricateListResp] = useState<IAggricateObj[]>([])
    const [measureSetList, setMeasureSetList] = useState<IMeasureSetList[]>([])
    const [filterValueOption, setFilterValueOption] = useState<FilterValueOption>('INCLUDE_ANY')
    const [currentHLDataType, setCurrentHLDataType] = useState<string>('')
    const [businessParameterList, setBusinessParameterList] = useState<IBusinessParameter[]>([])
    const [singleValueReportList, setSingleValueReportList] = useState<ISingleValueReportList[]>([])
    const [filterableMetaDataId, setFilterableMetaDataId] = useState<number>(-1)
    const [binList, setBinList] = useState<IBinResponseObj[]>([])
    const [selectedLeftItem, setSelectedLeftItem] = useState<IVUParamsSubCategory | any>({})
    const [metadataSearchResult, setMetadataSearchResult] = useState<IMetadataFilterSearchList[]>(
        []
    )
    const [paramsValidateState, setParamsValidateState] = useState<'error' | 'success' | "">("")
    const [bpDropDownOptions, setbpDropDownOptions] = useState<IBusinessParamsOptions[]>([])
    const [searchQuery, setSearchQuery] = useState('')
    const [NoBinAvailable, setNoBinAvailable] = useState<boolean>(true)
    
    //functions
    const {applyHighlight, highlightClass } = useApplyHighlight(FoundationsConstants.APPLY_HIGHLIGHT_DURATION);

    const getBusinessParameters = async (dataType: any) => {
        let dataTypepayload = { datatype: dataType }
        let businessParams: any = []
        try {
            businessParams = await callGetBusinessParameters(dataTypepayload).unwrap()
        } catch (err) {
            console.error('error from getting business parameters')
        }
        return businessParams?.data.BusinessParametersList
    }

    let CopyOfVuObjInfoFromStore: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(vuObjFromStore)]
    let vuIndex = getVisualUnitParamsIndex(vuId, CopyOfVuObjInfoFromStore)
    let measuresCount = CopyOfVuObjInfoFromStore[vuIndex].measures.length
    let rowOrganizerCount = CopyOfVuObjInfoFromStore[vuIndex].dimensionRow.length
    let columnOrganizerCount = CopyOfVuObjInfoFromStore[vuIndex].dimensionCol.length

    const isMeasure = paramsAction === 'addmeasure'
    const isRow = paramsAction === 'addrow'
    const isColumn = paramsAction === 'addcolumn'

    useEffect(() => {
        //FP-12098- Added just FoundationConstand count
        if (isMeasure &&  measuresCount == FoundationsConstants.ALLOWED_MEASURES) {
            onClose()
            return;
        }
        if (isRow && rowOrganizerCount == FoundationsConstants.ALLOWED_DIMENSIONS) {
            onClose()
            return;
        }
        if (isColumn && columnOrganizerCount == FoundationsConstants.ALLOWED_DIMENSIONS) {
            onClose()
            return;
        }
    }, [measuresCount, rowOrganizerCount, columnOrganizerCount])
    
//CLear all, Select all, Select checkbox all handled in Custom Hook
    const AddMeasureFromDialog = (call: "add" | "save"='add') => {
        let formedMeasureItem: any
        let selectedCategories = selectedLeftItem
        selectedCategoriesRef.current = selectedCategories //this is used in the showing dynamic validation message, selectedLeftItem not using directly which is triggering wrong message when cleared
        invalidParamsRef.current = false
        let selectedAggricateFn =
            aggrSelection.selected?.name || //forSingleValueCase
            aggrSelection.selected?.Name || ////for BusinessParam Case
            aggrSelection.selected?.AggregateFunction //for aggricate item case
        if (binList.length == 0) {
            setNoBinAvailable(true);
        }
        let validateSuccess = validateParams(
            selectedLeftItem,
            paramsAction,
            selectedAggricateFn, //this will undefined in the case of Filter
            availMeasures,
            updateIndex,
            onClose,
            aggrSelection.selected,
            currentHLDataType,
            NoBinAvailable
        )
        const isInvalidParams = isFilterCall(paramsAction) ? 
        checkIsInvalidFilter(genericFilterValRef.current, filterSelection.selected, businessParamChecked, bpObjectRef.current) : 
        isDimensioncall(paramsAction) ? checkIsInvalidDimension(selectedLeftItem) : 
        (!selectedAggricateFn)
        if (!validateSuccess || isInvalidParams) {
            if(isInvalidParams) invalidParamsRef.current = true
            setParamsValidateState('error')
            setTimeout(() => {
                applyHighlight('validation_failure', 'applyHighLight', {autoHide: false });
            }, 0);
            return //skipping other stuff
        } 
        if (paramsAction === 'addmeasure' || paramsAction === 'updateMeasure') {
            if (displayType === FoundationsConstants.FetchVuParamsDisplayType.SingleValueReportList) {
                //added helper function in vuParamsHelper to reduce code..
                formedMeasureItem = helperFormMeasureItem(
                    'singleValueItem',
                    paramsAction,
                    {},
                    selectedLeftItem,
                    aggrSelection.selected
                )
            } else if (displayType === FoundationsConstants.FetchVuParamsDisplayType.BusinessParameterList) {
                formedMeasureItem = helperFormMeasureItem(
                    'businessParameterItem',
                    paramsAction,
                    {},
                    selectedLeftItem,
                    aggrSelection.selected
                )
            } else if (displayType === FoundationsConstants.FetchVuParamsDisplayType.AggricateList) {
                formedMeasureItem = helperFormMeasureItem(
                    'aggricateItem',
                    paramsAction,
                    {},
                    selectedLeftItem,
                    aggrSelection.selected
                )
            }
            addMeasureFn(formedMeasureItem, call)
        } else if (paramsAction === 'addfilter' || paramsAction === 'updateFilter' ) {
            let formedFilterItem = helperFormFilterItem(
                genericFilterValRef.current,
                selectedLeftItem,
                filterSelection.selected,
                filterValueOption,
                businessParamChecked,
                bpObjectRef.current
            )
            let isValidDateFilters = validateGenericFilterValues(formedFilterItem, genericFilterValRef.current, businessParamChecked)

            if(isValidDateFilters){
                addMeasureFn(formedFilterItem, call)
            }else{
                invalidParamsRef.current = true
                setParamsValidateState('error')
                setTimeout(() => {
                    applyHighlight('validation_failure', 'applyHighLight', { autoHide: false });
                }, 0);
                return
            }
            
        } else if (
            paramsAction === 'addcolumn' ||
            paramsAction === 'addrow' ||
            paramsAction === 'updateRow' ||
            paramsAction === 'updateColumn'
        ) {
            
            let formedDimensionItem = helperFormDimensionItem(aggrSelection.selected, selectedLeftItem)
            addMeasureFn(formedDimensionItem, call)
        }
        if(isUpdateParamsCall(paramsAction) || call === 'save' || checkDimensionsCount(paramsAction, JSON.parse(vuObjFromStore)[vuIndex])){
            //FP-11627 checkDimensionsCount - in some cases for Add call for dimension we are closing the dialog
            onClose()
        }else{ //FP- 11627 directly close the dialog, w/o showing the success message.
            setParamsValidateState('success')
            setTimeout(() => {
                applyHighlight('validation_success', 'applyHighLight-success' , {autoHide: false });
                clearSelectedParams()
            }, 0);
        }
    }

    const formatGenericFilterValues = (props: TGetFilterVal) =>{
        if(businessParamChecked === 1){
            bpObjectRef.current = props.bpObject
        }
        let selectedMetadataObj = metadataSearchResult.find((item: any) => item.KeyValue == props.keyValue)
            genericFilterValRef.current = {...props, displayText: selectedMetadataObj?.DisplayText, id: selectedMetadataObj?.MetaDataId}
    }

    const selectFilterValueOption = (
        action: 'INCLUDE_ANY' | 'EXCLUDE_ANY' | 'INCLUDE_ALL' | 'EXCLUDE_ALL'
    ) => {
        setFilterValueOption(action)
    }

    const isAllowedRelatedFilter = () =>{
        let allowedTypes = ['addfilter', 'updateFilter', 'addcolumn', 'updateColumn', 'addrow', 'updateRow']
        return allowedTypes.includes(paramsAction)
    }

    const getFactGroups = (vuIndex: number, parsedParamsObject: VisualUnitApiDTO_EditSaveVisualUnit[]): any[] => {
        if (vuIndex < 0 || !parsedParamsObject[vuIndex]?.measures) return [];
    
        return [
            ...new Set(
                parsedParamsObject[vuIndex].measures
                    .filter(measure => measure.id > -1)
                    .flatMap(measure => measure.factGroup)
            )
        ];
    };

    const getCategories = (vuIndex: number, parsedParamsObject: VisualUnitApiDTO_EditSaveVisualUnit[]): string[] => {
        if (vuIndex < 0 || !parsedParamsObject[vuIndex]?.measures) return [];

        return [
            ...new Set(
                parsedParamsObject[vuIndex].measures
                    .filter(measure => measure.id > -1)
                    .flatMap(measure => measure.compCategoryName)
            )
        ];
    };


    const getConditionSelect=(selectType: string)=> {
        let parsedParamsObject = JSON.parse(vuObjFromStore)
        let vuIndex = getVisualUnitParamsIndex(vuId, parsedParamsObject)
        let conditionSelect: IFilterConditions = {conditionType: "", conditionData: null};
        conditionSelect.conditionType = selectType;

        if (selectType == 'narrow') {
            let measureFacts = getFactGroups(vuIndex, parsedParamsObject);
            conditionSelect.conditionData = measureFacts;
        }
        if (selectType == 'wide') {
            let measureCategories = getCategories(vuIndex, parsedParamsObject);
            conditionSelect.conditionData = measureCategories;
        }
        if (selectType == 'all') {
            conditionSelect.conditionData = null;
        }
        return conditionSelect;
    }

    const applyRelatedCatFilter = (refineMode: boolean, filtertype: string)=> {
        let allconditions: IFilterConditions[] = [];
        setSelectedCatFilter(filtertype)
        if (refineMode) {
            //check if required
        }
        else {
            let conditionSelect = getConditionSelect(filtertype);
            allconditions.push(conditionSelect);
        }
        let conditionObject: {conditions: IFilterConditions[]} = {conditions : [{conditionType: "", conditionData: null}]}
        conditionObject.conditions = allconditions;

        let fetchMetadata = isFilterCall(paramsAction)  ? 'filter' : 'stratifies'
        getHLMetadata(fetchMetadata, conditionObject)
    }

    const updateBusinessParamsRadioChecked = (value: 0 | 1) => {
        setBusinessParamChecked(value)
        if(value === 0){
            bpObjectRef.current = null
        }
    }

    const getFilterValueList = (
        filterableId: any,
        hlDataTypeString: string,
        isBusinessParameterFilter: any
    ) => {
        let bpList: any = []
        // handled in custom hook
        setFetchingResponse(true)
        if ((hlDataTypeString == FoundationsConstants.HLDATATYPE.HLDuration) ||
        (hlDataTypeString == FoundationsConstants.HLDATATYPE.HLNumber) ||
        (hlDataTypeString == FoundationsConstants.HLDATATYPE.HLCount) ||
        (hlDataTypeString == FoundationsConstants.HLDATATYPE.HLMoney)) {
        setShowBusinessParameter(true)
        } else {
            setShowBusinessParameter(false)
        }

        Promise.resolve(getBusinessParameters(hlDataTypeString.toString())).then((resp) => {
            bpList = resp
            if(bpList.length > 0){
                let bpdropdownOptions: IBusinessParamsOptions[] = [];
                bpList.forEach((element: IBusinessParamsOptions) => {
                    bpdropdownOptions.push({
                        Id: element.Id,
                        Guid: element.Guid,
                        Name: element.Name,
                        Description: element.Description,
                        DataType: element.DataType,
                        BPValue: element.BPValue,
                        IsSecured: element.IsSecured,
                        Available: element.Available,
                    })
                });
                setbpDropDownOptions(bpdropdownOptions)
            }
            let payload = { metaDataId: filterableId }
            switch (hlDataTypeString.toString()) {
                case FoundationsConstants.HLDATATYPE.HLList:
                    callGetMetaDataSearchList(payload)
                        .unwrap()
                        .then((resp) => {
                            if (resp.statusCode == 201) {
                                setMetadataSearchResult(resp.data.filterValueList)
                                if(resp.data.filterValueList.length > 15){
                                    showQuickSearchRef.current = true
                                }
                                setFetchingResponse(false)
                                setDisplayType(FoundationsConstants.FetchVuParamsDisplayType.HLLIST)
                                
                            }
                        }).then(()=> setIsAggrigateLoading(false))
                    break
                case FoundationsConstants.HLDATATYPE.HLSearchList:
                    // setShowSearchListDialog(true)
                    setFilterValueOption('INCLUDE_ANY')
                    setFetchingResponse(false)
                    setDisplayType(FoundationsConstants.FetchVuParamsDisplayType.HL_SEARCHLIST)
                    setIsAggrigateLoading(false)
                    break
                case FoundationsConstants.HLDATATYPE.HLAge:
                case FoundationsConstants.HLDATATYPE.HLAgeDays:
                case FoundationsConstants.HLDATATYPE.HLCount:
                case FoundationsConstants.HLDATATYPE.HLDate:
                case FoundationsConstants.HLDATATYPE.HLDuration:
                case FoundationsConstants.HLDATATYPE.HLMoney:
                case FoundationsConstants.HLDATATYPE.HLNumber:
                case FoundationsConstants.HLDATATYPE.HLDecimal:
                case FoundationsConstants.HLDATATYPE.HLTime:
                case FoundationsConstants.HLDATATYPE.HLText:
                   
                    callGetMetaDataSearchList(payload)
                        .unwrap()
                        .then((resp) => {
                            if (resp.statusCode == 201) {
                                if (paramsAction === 'updateFilter' && !isListItemClicked) {
                                    resp.data.filterValueList.forEach((itr: any, index: any) => {
                                        let filterValueListId = selectedParameters.data.filterValueListId
                                        if (itr.KeyValue == filterValueListId) {
                                            selectedDurationsFilter.current = itr.DisplayText
                                        }
                                    })
                                }
                                setMetadataSearchResult(resp.data.filterValueList)
                                setFetchingResponse(false)
                                setDisplayType(FoundationsConstants.FetchVuParamsDisplayType.GENERIC_FILTERS)
                            }
                        }).then(()=> {setIsAggrigateLoading(false); setFetchingResponse(false)})
                    break
            }
            setCurrentHLDataType(hlDataTypeString.toString())
        })
    }
    const getAggregateList = (measureId: number, hlDataTypeString: string) => {
        let hlDataType = parseInt(hlDataTypeString)
        let hlMeasureId = measureId
        let reqGetAggregateList: any = { hlDataType: 0, hlMeasureId: 0 }
        switch (hlDataTypeString.toString()) {
            case FoundationsConstants.HLDATATYPE.HLMeasureSet:
            try{
                callGetMeasureSets({})
                .unwrap()
                .then((response)=>{
                    if (response != null) {
                        let resultData = response.data;
                        if (resultData != null) {
                            // FIXME: No Case found where we are getting hl measureSets.
                            if (response.statusCode == 200) {
                                const response_MSetList :IMeasureSetList[] = resultData.MeasureSetList;
                                if (response_MSetList) {
                                    setMeasureSetList(response_MSetList)
                                    setFetchingResponse(false)
                                    showQuickSearchRef.current = true

                                }
                            }
                        }
                        setIsAggrigateLoading(false)
                    }
                })
            }catch (e){
                console.error('Error getting Measure Set List..')
            }
                break
            case FoundationsConstants.HLDATATYPE.HLBusinessParameter:
                reqGetAggregateList = {}
                callGetBusinessParamList(reqGetAggregateList)
                    .unwrap()
                    .then((resp) => {
                        let resultData = resp.data
                        setBusinessParameterList(resultData)
                        showQuickSearchRef.current = true
                        if (paramsAction === 'updateMeasure' && !isListItemClicked) {
                            //with isListItemClicked, making sure only first time this loop happens
                            resultData.forEach((itr: IBusinessParameter, _index: number) => {
                                if (itr.Name === selectedParameters.data?.aggegrateFunctionName) {
                                    aggrSelection.handleSelect({...resultData[_index], selectedIndex: _index})
                                    setFetchingResponse(false)
                                }
                            })
                        } else {
                            // aggrSelection.handleSelect({...resultData[0]}) //FP-11924 for single value report and business parameter first item should not be selected
                            setFetchingResponse(false)
                        }
                        setIsAggrigateLoading(false)
                    })
                    setDisplayType(FoundationsConstants.FetchVuParamsDisplayType.BusinessParameterList)
                break
            case FoundationsConstants.HLDATATYPE.HLSingleValueReport:
                let payload = { Value: vuId }
                callGetSingleValParamList(payload)
                    .unwrap()
                    .then((resp) => {
                        let singleValList = resp.data.SingleValueReportList
                        showQuickSearchRef.current = true
                        if (paramsAction === 'updateMeasure' && !isListItemClicked) {
                            //with isListItemClicked, making sure only first time this loop happens
                            singleValList.forEach((itr: ISingleValueReportList, _index: number) => {
                                if (itr.name === selectedParameters.data?.aggegrateFunctionName) {
                                    aggrSelection.handleSelect({...singleValList[_index], selectedIndex: _index})
                                    setFetchingResponse(false)
                                }
                            })
                        } else {
                            // aggrSelection.handleSelect({...singleValList[0], selectedIndex: 0}) //FP-11924 for single value report and business parameter first item should not be selected
                            setFetchingResponse(false)
                        }
                        setSingleValueReportList(singleValList)
                        setIsAggrigateLoading(false)
                    })
                    setDisplayType(FoundationsConstants.FetchVuParamsDisplayType.SingleValueReportList)
                break

            default:
                reqGetAggregateList.hlDataType = hlDataType
                reqGetAggregateList.hlMeasureId = hlMeasureId
                try{
                callGetAggricateList(reqGetAggregateList)
                    .unwrap()
                    .then((resp) => {
                        if (resp.data?.AggregateList as IAggricateObj[]) {
                            setAggricateListResp(resp.data?.AggregateList)
                            if (paramsAction === 'updateMeasure' && !isListItemClicked) {
                                //with isListItemClicked, making sure only first time this loop happens
                                resp.data?.AggregateList.forEach(
                                    (itr: IAggricateObj, _index: number) => {
                                        if (
                                            itr.AggregateFunction ===
                                            selectedParameters.data?.aggegrateFunctionName
                                        ) {
                                            aggrSelection.handleSelect({...resp.data?.AggregateList[_index], selectedIndex: _index})
                                            setFetchingResponse(false)
                                        }
                                    }
                                )
                            } else {
                                aggrSelection.handleSelect({...resp.data?.AggregateList[0], selectedIndex: 0})
                                setFetchingResponse(false)
                            }
                            setIsAggrigateLoading(false)
                        }
                    })
                    setDisplayType(FoundationsConstants.FetchVuParamsDisplayType.AggricateList)
                }
                catch (e){
                    console.error('Error calling Aggricate List', e)
                }
                break
        }
        
    }

    const expandCollapse = (cat_index: number) => {
        let currentExpandedCat = [...expandedCat]
        if (currentExpandedCat.includes(cat_index)) {
            currentExpandedCat = currentExpandedCat.filter((catIndex) => catIndex !== cat_index)
            setExpandedCategoris(currentExpandedCat)
        } else {
            setExpandedCategoris([...currentExpandedCat, cat_index])
        }
    }

    const showMetaDataFormModal = (type: string) => {}

    const clearSelectedParams = () => {
        setFilterValueOption('INCLUDE_ANY')
        setShowSelectionIndicator(null)
        aggrSelection.handleSelect({}) //here clear happens of custom hook. no need of other state
        filterSelection.handleSelect([])
        setDisplayType('')
        setBinList([])
        setCurrentHLDataType('')
        genericFilterValRef.current = null
        setShowBusinessParameter(true)
        updateBusinessParamsRadioChecked(0)
        setbpDropDownOptions([])
        ExpandedCatRef.current = null
        setSelectedLeftItem({})
        selectedDurationsFilter.current = ""
        setAggricateListResp([])
        setSingleValueReportList([])
        bpObjectRef.current = null
    }
    const selectListItemFromLeft = (item: any, userClicked = true, cat_index: number) => {
        setIsAggrigateLoading(true)
        showQuickSearchRef.current = false
        clearSelectedParams()
        setShowSelectionIndicator(cat_index)
        setFilterableMetaDataId(item.FieldKey)
        isListItemClicked = userClicked
        ExpandedCatRef.current = item.FieldKey
        setSelectedLeftItem(item)
        selectedCategoriesRef.current = item
        // Reset paramsValidateState when a new measure is selected
        setParamsValidateState("");
        switch (paramsAction) {
            case 'addmeasure':
            case 'updateMeasure':
                //here
                selectMeasureListItem(item) //Done
                break
            case 'addfilter':
            case 'updateFilter':
                selectFilterableListItem(item) //Done
                break
            case 'addrow':
            case 'updateRow':
                selectDimensionListItem(item)
                break
            case 'addcolumn':
            case 'updateColumn':
                selectDimensionListItem(item)
                break
        }
    }

    const selectDimensionListItem = (item: any) => {
        const binPayload = { _key: item?.FieldKey }
        let isMetadataEditModeEnabled = false
        setFetchingResponse(true)
        if (!isMetadataEditModeEnabled) {
            callGetBinList(binPayload)
                .unwrap()
                .then((response: { data: IBinResponseObj[] }) => {
                    if (response.data.length) {
                        if(response.data.length > 15){
                            showQuickSearchRef.current = true
                        }

                        if (
                            (isUpdateParamsCall(paramsAction)) &&
                            !isListItemClicked
                        ) {
                            response.data.forEach((itr: IBinResponseObj, _binIndex: number) => {
                                if (itr.Id === selectedParameters.data?.MetaDataBinId) {
                                    aggrSelection.handleSelect(itr)
                                    return
                                }
                            })
                        } else {
                            aggrSelection.handleSelect(response.data[0])
                        }
                    }
                    setBinList(response.data)
                    setFetchingResponse(false)
                })
        }
        setDisplayType(FoundationsConstants.FetchVuParamsDisplayType.BINLIST)
        setIsAggrigateLoading(false)
    }

    const selectFilterableListItem = (item: any) => {
        let isMetadataEditModeEnabled = false //FIXME:
        let filterableId = item.FieldKey
        let hlDataTypeString = item.DataType

        let isBusinessParameterFilter = ''
        if (isMetadataEditModeEnabled) {
            // healthLevelWorkspaceVU.showMetaDataFormModal(null, filterableId);
        } else {
            getFilterValueList(filterableId, hlDataTypeString, isBusinessParameterFilter)
        }
    }

    const selectMeasureListItem = (item: any) => {
        setBusinessParameterList([])
        setAggricateListResp([])
        setSingleValueReportList([])
        setFetchingResponse(true)
        let hlDataType = item?.DataType
        let hlMeasureId = item?.FieldKey
        let isMetadataEditModeEnabled = false
        if (isMetadataEditModeEnabled) {
        } else {
            getAggregateList(hlMeasureId, hlDataType)
        }
    }

    const chunkArray = (array: any[], size: number) => {
        const chunks = []
        if (array?.length > 0) {
            for (let i = 0; i < array?.length; i += size) {
                chunks.push(array.slice(i, i + size))
            }
        } else {
            return
        }
        return chunks
    }

    const fetchParams = () => {
        if (selectedParameters) {
            let index = categoriesData.indexOf(selectedParameters.data?.MetaData?.CategoryName)
            selectListItemFromLeft(selectedParameters.data?.MetaData, false, index) //Full item need to pass no any other
            setExpandedCategoris([index])
            setCatData(categoriesData)
            setGroupedCat(groupCategoriesData)
        }
    }
    const handleSearchCategories = () => {
        setExpandedCategoris([])
        const results: any = []
        Object.keys(groupCategoriesData).forEach((key) => {
            groupCategoriesData[key].forEach((item: any, index: number) => {
                const categoryName = item.CategoryName?.toLowerCase() || ''
                const fieldName = item.FieldName?.toLowerCase() || ''
                const fieldDesc = item.FieldDesc?.toLowerCase() || ''

                if (
                    categoryName.includes(searchQuery.toLowerCase()) ||
                    fieldName.includes(searchQuery.toLowerCase()) ||
                    fieldDesc.includes(searchQuery.toLowerCase())
                ) {
                    results.push(item)
                }
            })
        })
        let groupedCategories: any = Object.groupBy(results, (item: any) => item.CategoryName)
        setGroupedCat(groupedCategories)
        const indexes = Object.keys(groupedCategories).map((category: any) =>
            categoriesData.indexOf(category)
        )
        setExpandedCategoris([...indexes])
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery(searchQuery)
        }, 500)
        return () => {
            clearTimeout(handler) // Cleanup the timeout if searchQuery changes
        }
    }, [searchQuery])

    useEffect(() => {
        //use effect responsible to scroll to selected categories..
        if(isUpdateParamsCall(paramsAction) && noScrollRef.current === null){ //FP-11953 - WarRoom_30April, making first time scroll only.
            if (!isListItemClicked) {
                let lengthOfCategories = expandedCat.length
                let index = expandedCat[lengthOfCategories - 1] //scrolling to last element
                const targetElement = elementRef.current.get(index)
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth', block: "end" })
                    noScrollRef.current = false
                }
            }
        }
    }, [expandedCat])

    const setFetchedCategories = () => {
        setCatData(categoriesData)
        setGroupedCat(groupCategoriesData)
        setExpandedCategoris([])
    }

    useEffect(() => {
        if (firstFetchRef.current !== null) { //setFetchedCategories already calling in debouncedQuery useEffect. no need to call in this render first time
            setFetchedCategories()
            if (selectedCatFilter === 'wide' || selectedCatFilter === 'narrow') {
                let expandedIndexes = categoriesData.map((_: any, index: number) => index);
                setExpandedCategoris(expandedIndexes)
            } else {
                setExpandedCategoris([])
            }
            clearSelectedParams()
        }else{
            firstFetchRef.current = false
        }
    }, [categoriesData])

    useEffect(() => {
        if (!debouncedQuery.trim() && isAddParmsCall(paramsAction)) {
            setFetchedCategories()
            firstFetchRef.current = false
            return
        } else {
            handleSearchCategories()
        }
    }, [debouncedQuery])

    useEffect(() => {
        if (isUpdateParamsCall(paramsAction)) {
            fetchParams()
        }
    }, [])

    return (
        <React.Fragment>
            <div
                id="vu_params_popup_dialog_wrapper"
                className="hide ui-dialog-content ui-widget-content"
                style={{
                    display: 'block',
                    minHeight: '42.281px',
                    maxHeight: 'none',
                    height: 'auto',
                    minWidth: '70%',
                    width: 'auto'
                }}
            >
                <table className="vu-popup-table-wrapper" style={{ width: "100%", tableLayout: "fixed" }}>
                    <tbody>
                        <tr>
                            <td className="vu-popup-left-col" style={{ width: "auto",  verticalAlign: 'top' }}>
                                <div className="quick-search">
                                    <div
                                        id="vu_popup_fields_search_wrapper"
                                        className="search-text-wrapper"
                                    >
                                        <span className="search-image"></span>
                                        <input
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            type="text"
                                            placeholder='Search...'
                                            id="vu_params_search_text"
                                            value={searchQuery}
                                            className="input-text"
                                        />
                                        <span
                                            className="placeholder-text"
                                            style={{ display: 'none' }}
                                        >
                                            search...
                                        </span>
                                        <span className="clear-both"></span>
                                        {
                                        isAllowedRelatedFilter() &&
                                        <select onChange={(e)=>applyRelatedCatFilter(false,e.target.value)} id="selectType_filter_41887" className="selectType">
                                            <option selected={selectedCatFilter ==="wide" } value="wide">Categories</option>
                                            <option selected={selectedCatFilter ==="narrow" } value="narrow">Related Categories</option>
                                            <option selected={selectedCatFilter ==="all" } value="all">All</option>
                                        </select>
                                        }
                                    </div>
                                </div>
                                <div
                                    id="vu_popup_elements_table"
                                    className="vu-popup-elements-table"
                                >
                                    <table
                                        id="vu_filterable_list_table"
                                        className="filterable-list"
                                    >
                                        <tbody>
                                            {catData?.map((category: string, cat_index: number) => {
                                                // let lengthOfCat = groupedCat[category]?.length
                                                const rows = chunkArray(groupedCat[category], 2)
                                                return (
                                                    <React.Fragment>
                                                        <tr key={`categories_${cat_index}`}>
                                                            <td
                                                                className="category"
                                                                colSpan={2}
                                                            >
                                                                {category}
                                                                <i
                                                                    className="add-meta-data"
                                                                    onClick={() =>
                                                                        showMetaDataFormModal('')
                                                                    }
                                                                >
                                                                    +
                                                                </i>
                                                                <i
                                                                    className="categoryUpArrow float-left AutoTest"
                                                                    onClick={() =>
                                                                        expandCollapse(cat_index)
                                                                    }
                                                                >
                                                                    {expandedCat.includes(cat_index)
                                                                        ? '▼'
                                                                        : '►'}
                                                                </i>
                                                                {/* <i className="categoryDownArrow float-left AutoTest" style={{ "display": "none" }} onClick={() => expandCollapse(cat_index)}>▼</i> */}
                                                                <SelectionIndicator selectedIndex={showSelectionIndicator} currentIndex ={cat_index}/>
                                                                <span className="selection-indicator"></span>
                                                            </td>
                                                        </tr>
                                                        {expandedCat.includes(cat_index) &&
                                                            rows?.map(
                                                                (row: any[], rowIndex: any) => (
                                                                    <tr
                                                                        className="fieldrow"
                                                                        key={`expandedCategory_${rowIndex}`}
                                                                    >
                                                                        {row.map(
                                                                            (
                                                                                item: any,
                                                                                itemIndex: number
                                                                            ) => {
                                                                                return (
                                                                                    <td
                                                                                    ref={(el) => { //FP-11851 - Scroll element should be sub categories
                                                                                        if (el)
                                                                                            elementRef.current.set(
                                                                                                cat_index,
                                                                                                el
                                                                                            )
                                                                                    }}
                                                                                        key={`expandedRow_${item?.FieldKey}`}
                                                                                        id={`filterable_item_${item?.FieldKey}`}
                                                                                        className={
                                                                                            ExpandedCatRef.current ===
                                                                                            item.FieldKey
                                                                                                ? `fielditem selected`
                                                                                                : 'fielditem not-selected'
                                                                                        }
                                                                                        onClick={() =>
                                                                                            selectListItemFromLeft(
                                                                                                item, true, cat_index
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <div className="float-left fieldradio"
                                                                                             style={{ width: '20px' }}
                                                                                        >
                                                                                            <input
                                                                                                checked={
                                                                                                    ExpandedCatRef.current ===
                                                                                                    item.FieldKey
                                                                                                }
                                                                                                type="radio"
                                                                                                id={`filterable_radio_${item?.FieldKey}`}
                                                                                                name="filterable_radio"
                                                                                                readOnly
                                                                                            />
                                                                                        </div>
                                                                                        <div className="float-left fieldcontent">
                                                                                            <div className={`fieldname ${!item.DisplayInPalette
                                                                                                ? 'field-validation-error'
                                                                                                : ''
                                                                                                }`}>
                                                                                                {item.FieldName}
                                                                                            </div>
                                                                                            <div className={`fielddesc ${(!item?.FieldDesc) ? 'field-validation-error' : ''}`}>
                                                                                                {item?.FieldDesc || 'Field Description Required'}
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                )
                                                                            }
                                                                        )}
                                                                    </tr>
                                                                )
                                                            )}
                                                    </React.Fragment>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        
                            <VuParamsFilterRegion
                                showQuickSearch={showQuickSearchRef.current}
                                selectFilterValueOption={selectFilterValueOption}
                                // for useHook
                                aggrSelection={{ ...aggrSelection }}
                                filterSelection={{ ...filterSelection }}

                                metadataSearchResult={metadataSearchResult}
                                binMetadataData={{ binList }}
                                filterableMetaDataId={filterableMetaDataId}
                                paramsAction={paramsAction}
                                currentHLDataType={currentHLDataType}
                                setBusinessParamChecked={updateBusinessParamsRadioChecked}
                                showBusinessParameter={showBusinessParameter}
                                businessParamChecked={businessParamChecked} 
                                isAggrigateLoading={isAggrigateLoading}
                                fetchingResp={fetchingResponse}
                                selectedLeftItem={selectedLeftItem}
                                displayType={displayType}
                                singleValueReportList={singleValueReportList}
                                businessParameterList={businessParameterList}
                                aggricateListResp={aggricateListResp}
                                selectedParameters={selectedParameters}
                                //For Durations filter
                                formatGenericFilterValues={formatGenericFilterValues}
                                selectedDurations={selectedDurationsFilter.current}
                                bpDropDownOptions={bpDropDownOptions}
                            />
                            
                        </tr>
                    </tbody>
                </table>
                {
                    paramsValidateState === "error" &&
                    <div
                        id="vu_popup_dialog_message_error"
                        className={`d-none ${highlightClass?.validation_failure ?? ""} `} //we are removing this d-none in useApplyHighlight hook
                        style={{fontSize: '13px', color:'red'}}
                    >
                        {formedErrorText(paramsAction, invalidParamsRef.current, "error", selectedCategoriesRef.current)}
                    </div>
                }
                {
                    paramsValidateState === "success" &&
                    <div
                        id="vu_popup_dialog_message_success"
                        className={`d-none ${highlightClass?.validation_success ?? ""}`} //we are removing this d-none in useApplyHighlight hook, and adding it back in same fn.
                    >
                        {formedErrorText(paramsAction, invalidParamsRef.current, "success", selectedCategoriesRef.current)}
                    </div>
                }
            </div>
            <div className="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
                <div className="ui-dialog-buttonset">
                    <button
                        type="button"
                        className="app-button float-right ui-button ui-corner-all ui-widget negative"
                        onClick={() => onClose()}
                    >
                        Close
                    </button>
                    {
                    isAddParmsCall(paramsAction) ?
                    <React.Fragment>
                    <button
                        onClick={() => {
                            AddMeasureFromDialog('save');
                        }}
                        type="button"
                        className="app-button float-right ui-button ui-corner-all ui-widget"
                    >
                        Save and Close
                    </button>
                    <button
                        onClick={() => AddMeasureFromDialog()}
                        type="button"
                        className="app-button float-right ui-button ui-corner-all ui-widget"
                    >
                        Add
                    </button>
                    </React.Fragment>
                    :
                    <button
                        onClick={() => {
                            AddMeasureFromDialog('save');
                        }}
                        type="button"
                        className="app-button float-right ui-button ui-corner-all ui-widget"
                    >
                        Save
                    </button>
                    }
                    <button
                        type="button"
                        className="app-button float-right ui-button ui-corner-all ui-widget"
                    >
                        Edit Metadata
                    </button>
                </div>
            </div>
        </React.Fragment>
    )
}

export default VisualUnitParamsDialog
